module.exports = __webpack_public_path__ + "static/media/puzzle-piece.5b4da49d.svg";